import React from 'react'
import { FormattedMessage } from 'react-intl'
import { OptimizelyExperiments } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'LuxKit/Button/TextButton'

export function ViewOfferButton(
  {
    variant,
    textOnly = false,
  }:
  {
    variant: 'default' | 'condensed'
    textOnly?: boolean
  },
) {
  const testVariant: 'control' | 'see_deal' | undefined = useOptimizelyExperiment(OptimizelyExperiments.croOfferCtaSeeDeal)
  if (textOnly) {
    if (testVariant === 'see_deal') {
      return <FormattedMessage id="m0HkkmT3eZ" defaultMessage="See deal" />
    } else {
      return <FormattedMessage id="a4g52Ts26R" defaultMessage="View offer" />
    }
  } else {
    if (variant === 'default') {
      return <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          <FormattedMessage id="FgydNeoT78" defaultMessage="View" />
        </TextButton>
      </CSSBreakpoint>
    } else if (variant === 'condensed' && testVariant === 'see_deal') {
      return <TextButton kind="secondary" nonInteractable>
        <FormattedMessage id="LH+7bbY00e" defaultMessage="See" description="First word of 'See deal' button text. The word 'deal' follows on desktop only." /> <CSSBreakpoint as="span" min="desktop">&nbsp;<FormattedMessage id="r6UWF1ne0u" defaultMessage="deal" description="Second word of 'See deal' button text. Only visible on desktop screens." /></CSSBreakpoint>
      </TextButton>
    } else {
      return <TextButton kind="secondary" nonInteractable>
        <FormattedMessage id="f/gmxBuvRv" defaultMessage="View" description="First word of 'View offer' button text. The word 'offer' follows on desktop only." /> <CSSBreakpoint as="span" min="desktop">&nbsp;<FormattedMessage id="2SAs8XoaR5" defaultMessage="offer" description="Second word of 'View offer' button text. Only visible on desktop screens." /></CSSBreakpoint>
      </TextButton>
    }
  }
}
